module.exports = __webpack_public_path__ + "static/october-4-1f8d49ec59f10d1f4933e2449a1554fe.jpg";